export default __webpack_public_path__ + "static/media/2.29ce87e5.png";